import * as React from "react"

import CookieNotice from "./CookieNotice"

export default function RootWrapper({ children }) {
  return (
    <>
      {children}
      <CookieNotice />
    </>
  )
}
